import { observable } from "mobx";
import { Type } from "class-transformer";
import DateRangeRequest from "./dateRangeRequest";
import DecimalRangeRequest from "./decimalRangeRequest";
import OutgoingTransferPaymentStatus from "./outgoingTransferPaymentStatus";
import type { EntityValidationRules } from "../services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OutgoingTransferPaymentsRequest {
  @observable
  fullTextSearchEnabled?: boolean;

  @observable
  countryId?: string;

  @observable
  licensePlate?: string;

  @observable
  variableSymbol?: number;

  @observable
  @Type(() => DateRangeRequest)
  postingDate?: DateRangeRequest;

  @observable
  @Type(() => DateRangeRequest)
  exportedDate?: DateRangeRequest;

  @observable
  @Type(() => DecimalRangeRequest)
  paidAmount?: DecimalRangeRequest;

  @observable
  accountNumber?: string;

  @observable
  bank?: string;

  @observable
  messageForRecipient?: string;

  @observable
  officialRecordId?: string;

  @observable
  status?: OutgoingTransferPaymentStatus;

  @observable
  isUnidentified?: boolean;

  @observable
  chargeId?: string;

  @observable
  chargeOrderId?: string;
}

export const OutgoingTransferPaymentsRequestValidationRules: EntityValidationRules<OutgoingTransferPaymentsRequest> = {
  variableSymbol: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  messageForRecipient: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  officialRecordId: {
    isLength: {
      min: 3,
      max: 50,
      optional: true,
    },
  },
  licensePlate: {
    isLicensePlate: {
      required: false,
    },
    isLength: {
      min: 1,
      optional: true,
    },
  },
  accountNumber: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  bank: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  paidAmount: {
    isNumberRange: {
      min: 0,
    },
  },
  chargeOrderId: {
    isLength: {
      min: 32,
      max: 36,
      optional: true,
    },
  },
  chargeId: {
    isLength: {
      min: 32,
      max: 36,
      optional: true,
    },
  },
};
